<template>
  <div class="container page">
    <van-nav-bar :title="$t('项目历史')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="record">
      <van-empty v-if="list.length === 0" :description="$t('msg.没有更多了')"/>
      <div v-else class="item_list" v-for="(v,keys) in list" :key="keys">
        <div class="scroll-view-item">
          <div class="betRecord-rightTxt">
            <div class="flex-between headFrom mb-[32rpx]">
              <div class="yzj">{{ v.name }} ({{ v.expect }})</div>
              <div class="fontWarning" v-if="v.status == 0">{{ $t("正在连接") }}</div>
              <div class="fontWarning" v-else-if="v.status == 1 && v.zj_count > 0">{{ $t("已连接") }}</div>
              <div  v-else >{{ $t("未连接") }}</div>
            </div>
            <div class="u-flex flex-between mb-[24rpx]">
              <div class="u-font-24 w-[160rpx]">{{ $t("购买单类型") }}:</div>
              <div style="color: rgb(42, 53, 99); text-align: right;">{{ $t("规格") }}</div>
            </div>
            <div class="u-flex flex-between mb-[24rpx]">
              <div class="u-font-24 w-[160rpx]">{{ $t("期数") }}:</div>
              <div style="color: rgb(42, 53, 99); text-align: right;">{{ v.expect.substring(v.expect.length - 3) }}</div>
            </div>
            <div class="u-flex flex-between mb-[24rpx]">
              <div class="u-font-24 w-[160rpx]">{{ $t("投注号码") }}:</div>
              <div style="color: rgb(42, 53, 99); text-align: right;">
                  <span v-for="(item,key) in v.match_number_result" :key="key">
                    <span v-if="key > 0">,</span>
                    <span>{{ $t(item) }}</span>
                  </span>
              </div>
            </div>
            <div class="u-flex flex-between mb-[24rpx]">
              <div class="u-font-24 w-[160rpx]">{{ $t("订单时间") }}:</div>
              <div style="color: rgb(42, 53, 99); text-align: right;">{{ v.create_time }}</div>
            </div>
            <div class="u-flex flex-between mb-[24rpx]">
              <div class="u-font-24 w-[160rpx]">{{ $t("连接代码") }}:</div>
              <div style="color: rgb(42, 53, 99); text-align: right;" v-if="v.status == 1">
                  <span v-for="(item,key) in v.opencode" :key="key">
                    <span v-if="key > 0">,</span>
                    <span>{{ item }}</span>
                  </span>

              </div>
            </div>
            <div class="u-flex flex-between">
              <div class="u-font-24 w-[160rpx]">{{ $t("钱") }}:</div>
              <div style="color: rgb(42, 53, 99); text-align: right;">
                {{ formatNumber(v.money) }}, {{ $t("单个连接数") }}:{{ v.zj_count }}, {{ $t("连接金额") }}:{{ formatNumber(v.zj_num) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('msg.刷新成功！'));
        this.isLoading = false;
      }, 500);
    },
    getUserGameList() {
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data;
          console.log(this.list)
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    }

  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserGameList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.record{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 24vw;
  margin-top: 16vw;
}
.scroll-view-item {
  margin: 20px 50px;
  padding: 0 .625rem 1rem;
  background: #fff;
  border-radius: .5rem;
  box-shadow: 0 5px 10px rgba(0, 0, 0, .05);
  border: 1px solid #dfe8f6;
  color: #848fac;
}

.scroll-view-item .headFrom {
  height: 2.875rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dfe8f6
}

.scroll-view-item .headFrom .yzj, .scroll-view-item .headFrom .fontRed {
  color: #ff3900;
  font-size: .75rem
}

.scroll-view-item .headFrom .fontWarning {
  color: #ff7d01
}

.scroll-view-item .headFrom uni-text {
  color: #2a3563;
  font-size: .875rem
}

.scroll-view-item .flex-between {
  display: flex;
  justify-content: space-between
}
.u-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.mb-\[24rpx\] {
  margin-bottom: .75rem;
}
.mb-\[32rpx\]{
  margin-bottom: 1rem;
}
.u-font-24 {
  font-size: .75rem;
}

.w-\[160rpx\] {
  width: 5rem;
}
</style>
